import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ranking-index-view-pc"
};
import { onMounted } from "vue";
import { disableHeaderActive } from "@/utils/topic/topicUtils";
export default {
  __name: 'RankingIndexViewPC',
  setup(__props) {
    onMounted(() => {
      disableHeaderActive();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)]);
    };
  }
};